import { EhrType, TaskStatusCode } from "list-types-public";

export interface Task {
  _id?: string;
  type: TaskType;
  subType: string;
  executingUser?: string;
  executingUserName?: string;
  srcType?: EhrType;
  referralId?: string;
  status?: TaskStatus;
  updateStatusMsg?: TaskUpdateStatusMessage;
  data: TaskReferralResponse;
  messages: TaskMessage[];
  statusCode?: TaskStatusCode;
  regionId?: string;
  callbackData?: TaskCallbackData;
}

/** The EHR sites the logged-in scraper can actually act on for this referral. */
export interface AvailableSite {
  siteName: string;
  responseStatus?: string;
  respondByDate?: string;
  lastActivityDate?: string;
  /** Can the provider still submit a status response for THIS site? (Ensocare per-site flag.) */
  isRespondEnabled?: boolean;
  /** Is messaging available for THIS site? Ensocare: true only for Booked referrals. */
  isMessageEnabled?: boolean;
}

// The AllScripts scraper persists availableSites as an index-keyed object
// ({ "0": {...}, "1": {...} }); other paths may use an array. Accept both.
export type AvailableSites = AvailableSite[] | Record<string, AvailableSite>;

/** Scraper-populated data returned on the task (e.g. AllScripts/Ensocare selectPatient).
 * Mirrors list-types-public SelectPatientCallbackData. */
export interface TaskCallbackData {
  availableSites?: AvailableSites;
  isRespondEnabled?: boolean;
  /** Referral-level: is messaging available (often true even when responding is closed)? */
  isMessageEnabled?: boolean;
  /** Human-readable reason when responding is disabled. */
  displayMsg?: string;
  /** Typed reason code (scraper statusCodes, e.g. response_deadline_passed). */
  statusCode?: string;
}

export enum TaskStatus {
  Hold = 'hold',
  Start = 'start',
  Done = 'done',
  Error = 'error',
}

export enum TaskUpdateStatusMessage {
  Error = 'Failed',
  Pending = 'Pending',
  Done = 'Done',
}

export enum TaskType {
  ReferralResponse = 'referralResponse',
}

export interface TaskMessage {
  type: TaskMessageType;
  message: string;
  from: TaskMessageFrom;
  read: boolean;
}

export enum TaskMessageType {
  LoginSuccess = 'loginSuccess', 
  LoginError = 'loginError', 
  NeedCredentials = 'needCredentials', 
  NeedPasswordReset = 'needPasswordReset', 
  CredentialsUpdate = 'credentialsUpdate',
}

export enum TaskMessageFrom {
  Ehr = 'ehr',
  Client = 'client',
}

export interface TaskReferralResponse {
  referralId: string;
  srcType?: EhrType;
  responses: Record<string, TaskReferralResponseData>,
  regionId?: string;
}

export interface TaskReferralResponseData {
  response: string;
  responseReason?: string;
  responseSubReason?: string;
  dateForAdmission?: string;
  timeForAdmission?: string;
  comment?: string;
  subject?: string;
  phone?: string;
  callMe?: boolean;
  regionId?: string;
}

export interface TaskReferralResponseDataEpic {
  response: string;
  responseReason?: string;
  comment?: string;
  subject?: string;
  phone?: string;
  callMe?: boolean;
  regionId?: string;
}